export default "__VITE_ASSET__DuR1N8Cy__"